import React from "react";
import ApplicationRoutes from "./router/application-routes";
import { ConfigProvider } from "antd";

const AppRoutes = () => {
  return (
    <>
      <ConfigProvider
        theme={{
          token: {
              colorPrimary: '#001529',
              colorLink: '#1eaa7d',
              colorSuccess: '#52c41a',
              colorWarning: '#faad14',
              colorError: '#FF0000',
              colorBorder: '#1eaa7d!',
              boxShadow: 'none !important',
              fontFamily: `'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
          'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
          'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
          },
        }}
      >
        <ApplicationRoutes />
      </ConfigProvider>
    </>
  );
};
export default AppRoutes;
